export const TagsKey = 'tags';
export const PartAllocatedTagsKey = 'partAllocatedTags';